import { Smartphone, RefreshCw, Signal, Wifi, Zap, Headphones, Cable, ArrowUpRight } from "lucide-react";
import { Reveal } from "./Reveal";
import { IMAGES } from "../../lib/site";

const services = [
  { icon: Smartphone, title: "Smartphone nuovi", desc: "Gli ultimi modelli dei migliori brand, pronti alla consegna con configurazione inclusa.", href: "#telefoni" },
  { icon: RefreshCw, title: "Smartphone usati garantiti", desc: "Dispositivi ricondizionati e testati, con garanzia reale. Qualità a prezzo giusto.", href: "#telefoni" },
  { icon: Signal, title: "Offerte mobile", desc: "Confrontiamo tutti gli operatori per trovare la tariffa più conveniente per te.", href: "#offerte-mobile" },
  { icon: Headphones, title: "Assistenza & configurazione", desc: "Trasferimento dati, backup e setup completo del tuo nuovo dispositivo.", href: "#contatti" },
  { icon: Cable, title: "Accessori", desc: "Cover, cavi, caricatori e protezioni originali e certificati.", href: "#contatti" },
];

export const Services = () => (
  <section id="servizi" data-testid="services-section" className="bg-white py-24 md:py-32">
    <div className="max-w-7xl mx-auto px-6 md:px-12">
      <Reveal>
        <p className="text-xs md:text-sm uppercase tracking-[0.2em] font-bold text-brand">I nostri servizi</p>
        <h2 className="font-display font-bold tracking-tight text-3xl md:text-4xl lg:text-5xl mt-3 max-w-2xl">
          Tutto ciò di cui hai bisogno, sotto lo stesso tetto.
        </h2>
      </Reveal>

      <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
        {/* Featured: Fibra */}
        <Reveal className="lg:col-span-2 lg:row-span-2">
          <a href="#fibra" data-testid="service-card-fibra" className="group relative block h-full min-h-[20rem] rounded-3xl overflow-hidden bg-ink text-white p-8 md:p-10 flex flex-col justify-end">
            <img src={IMAGES.fiber} alt="Fibra casa" className="absolute inset-0 w-full h-full object-cover opacity-70 group-hover:scale-105 transition-transform duration-700" />
            <div className="absolute inset-0 bg-gradient-to-t from-ink via-ink/60 to-transparent" />
            <div className="relative">
              <Wifi className="w-8 h-8 text-brand mb-4" strokeWidth={1.5} />
              <h3 className="font-display font-bold text-2xl md:text-3xl">Fibra casa</h3>
              <p className="mt-2 text-white/70 max-w-md">Internet ultraveloce per la tua abitazione. Ti troviamo la connessione migliore per copertura e prezzo, con attivazione gestita da noi.</p>
            </div>
          </a>
        </Reveal>

        {/* Featured: Luce e Gas */}
        <Reveal delay={0.05}>
          <a href="#luce-gas" data-testid="service-card-luce-gas" className="group relative block h-full min-h-[20rem] rounded-3xl overflow-hidden bg-ink text-white p-8 flex flex-col justify-end">
            <img src={IMAGES.energy} alt="Luce e Gas" className="absolute inset-0 w-full h-full object-cover opacity-70 group-hover:scale-105 transition-transform duration-700" />
            <div className="absolute inset-0 bg-gradient-to-t from-ink via-ink/50 to-transparent" />
            <div className="relative">
              <Zap className="w-8 h-8 text-brand mb-4" strokeWidth={1.5} />
              <h3 className="font-display font-bold text-2xl">Luce e Gas</h3>
              <p className="mt-2 text-white/70">Confronto tra i fornitori per ridurre le tue bollette.</p>
            </div>
          </a>
        </Reveal>

        {services.map((s, i) => (
          <Reveal key={s.title} delay={i * 0.05}>
            <a href={s.href} data-testid={`service-card-${i}`} className="group block h-full rounded-3xl bg-[#FAFAFA] border border-neutral-100 p-8 hover:shadow-2xl hover:shadow-black/5 hover:-translate-y-1 transition-[transform,box-shadow] duration-300">
              <div className="flex items-start justify-between">
                <div className="w-12 h-12 rounded-2xl bg-brand-soft flex items-center justify-center">
                  <s.icon className="w-6 h-6 text-brand" strokeWidth={1.5} />
                </div>
                <ArrowUpRight className="w-5 h-5 text-neutral-300 group-hover:text-brand transition-colors" />
              </div>
              <h3 className="font-display font-semibold text-xl mt-6">{s.title}</h3>
              <p className="mt-2 text-neutral-500 leading-relaxed">{s.desc}</p>
            </a>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
